module.exports = __webpack_public_path__ + "img/avatar.cd8b81e0.jpg";